export default __webpack_public_path__ + "static/better-care-9ffe52323bc545db13042f64e99e3227.webm";